var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CatalogLocationInfo bb-text-darkgray bb-p-2 bb-border-radius-4"},[_c('p',{staticClass:"bb-bold bb-mb-2"},[_vm._v(_vm._s(_vm.location.location.address))]),_vm._v(" "),_c('p',{staticClass:"bb-mb-2"},[_c('span',[_vm._v(" "+_vm._s(_vm.phoneAndEmail)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }